import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { config } from './config' 

import CoreuiVue from '@coreui/vue'
import CIcon from '@coreui/icons-vue'
import { iconsSet as icons } from '@/assets/icons'
//import DocsExample from '@/components/DocsExample'

import Vue3EasyDataTable from 'vue3-easy-data-table';
import 'vue3-easy-data-table/dist/style.css';

import "toastify-js/src/toastify.css"
import './assets/css/fonts.css';
//app.component('DocsExample', DocsExample)

const injectPersonalizacion = async () => {
    try {

        const response = await fetch(`${config.backendUrl}/personalizacion/public`);
        
        if (!response.ok) {
            console.warn('No se pudo cargar la personalización');
            return;
        }

        const data = await response.json();
        
        if (!data.status || !data.data) {
            console.warn('Respuesta de personalización inválida');
            return;
        }

        const { cssCustom, jsCustom } = data.data;

        if (cssCustom && cssCustom.trim() !== '') {
            const styleElement = document.createElement('style');
            styleElement.id = 'personalizacion-css-custom';
            styleElement.textContent = cssCustom;
            document.head.appendChild(styleElement);
        }

        if (jsCustom && jsCustom.trim() !== '') {
            const scriptElement = document.createElement('script');
            scriptElement.id = 'personalizacion-js-custom';
            scriptElement.textContent = jsCustom;
            document.body.appendChild(scriptElement);
        }

    } catch (error) {
        console.error('Error al cargar personalización:', error);
    }
};


injectPersonalizacion().then(() => {
    
    const app = createApp(App)
    app.use(store)
    app.use(router)
    app.use(CoreuiVue)
    app.provide('icons', icons)
    app.component('CIcon', CIcon)
    app.component('EasyDataTable', Vue3EasyDataTable);

    app.mount('#app')
});
